<template>
    <div class="p-0">
        <div class="row page-container">
            <div class="col-md-12 d-flex justify-content-between align-items-center p-0">
                <span class="header-text" v-if="(!editFlag && currentPage.btnHeaderShow)">Settings</span>
                <router-link class="back-route h1" @click="backHandler" :to="currentPage.backRoute"
                             v-if="(editFlag || currentPage.btnBackShow) && isAction">
                    <img src="../../assets/images/back.svg" height="19">
                    {{editFlag ? 'Edit':'Create'}} {{ currentPage.title.charAt(0).toUpperCase() +
                    currentPage.title.substring(1) }}
                </router-link>
                <Transition>
                    <router-link :to="currentPage.to" id="entities-btn"
                                 v-if="permissions.includes('create '+currentPage.title) && (currentPage.access && currentPage.btnShow) && isAction || isSearch"
                                 @click="btnCreateActionsHandler"
                                 class="text-decoration-none btn-container">Create {{ currentPage.title.charAt(0).toUpperCase() +
                        currentPage.title.substring(1) }}
                    </router-link>
                </Transition>

            </div>
            <div class="tab p-0 pt-3">
                <router-link @click="btnActionsHandler('role','roles')" to="/settings/roles"
                             class="text-decoration-none tablinks h2 m-0"
                             :class="{'active': subIsActive('/settings/roles')}" v-if="permissions.includes('viewAny role')">Roles
                </router-link>

                <router-link @click="btnActionsHandler('user','user')" to="/settings/user"
                             class="text-decoration-none tablinks h2 m-0"
                             :class="{'active': subIsActive('/settings/user')}" v-if="permissions.includes('viewAny user')">User
                </router-link>

                <router-link @click="btnActionsHandler('teams','teams')" to="/settings/teams"
                             class="text-decoration-none tablinks h2 m-0"
                             :class="{'active': subIsActive('/settings/teams')}" v-if="permissions.includes('viewAny team')">Teams
                </router-link>
            </div>

            <router-view @data-event="dataEvent"/>

            <AlartModal v-if="successModal" :message="successMessage" imagePath="okImage.svg"
                        @close-modal="closeSuccessModalHandler"/>
            <AlartModal v-if="errorModal" :message="errorMessage" imagePath="close.png"
                        @close-modal="closeErrorModalHandler"/>

        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, computed, defineAsyncComponent, ref} from "vue";
    import {useStore} from 'vuex';
    import {useRoute} from 'vue-router';


    const AlartModal = defineAsyncComponent(() =>
        import ('./../components/AlartModal')
    );
    export default {
        name: 'settings-page',
        components: {AlartModal},
        setup() {
            const route = useRoute();
            const currentPage = reactive({
                name: '',
                title: '',
                to: '',
                backRoute: '',
                access: false,
                btnBackShow: false,
                btnShow: false,
                btnHeaderShow: false
            });
            const isAction = ref(false);
            const isSearch = ref(false);
            const permissions = ref([]);
            let originalUrlPage = ref('');
            const errorModal = ref(false);
            const store = useStore();
            onMounted(async () => {
                await store.dispatch('activeTap', 'settings');
                permissions.value = await store.state.auth.permissions;
                let urlSplit = route.path.split('/');
                let urlPage = '';
                if (urlSplit.length > 3) {
                    urlPage = urlSplit[2] === 'entities' ? 'entity' : urlSplit[2];
                    originalUrlPage.value = urlSplit[urlSplit.length - 2];
                    currentPage.btnBackShow = true;
                    currentPage.btnShow = false;
                    currentPage.btnHeaderShow = false;
                    await store.dispatch('setBtnHeader', false);
                } else {
                    urlPage = urlSplit[urlSplit.length - 1] === 'entities' ? 'entity' : urlSplit[urlSplit.length - 1];
                    originalUrlPage.value = urlSplit[urlSplit.length - 1];
                    currentPage.btnBackShow = false;
                    currentPage.btnShow = true;
                    currentPage.btnHeaderShow = true;
                    store.dispatch('setBtnHeader', true)
                }


                permissions.value = store.state.auth.permissions;
                currentPage.title = urlPage === 'teams' ? 'team' : urlPage === 'roles'?'role':urlPage;
                currentPage.name = urlPage === 'teams' ? 'entity' : (urlPage === 'roles'?'role':urlPage);
                currentPage.to = '/settings/' + originalUrlPage.value + '/create';
                currentPage.access = permissions.value.includes('create ' + `${currentPage.name}`);
                let to = currentPage.to.split('/');
                currentPage.backRoute = store.state.settings.editFlag ? '/' + urlSplit[1] + '/' + urlSplit[2] : '/' + to[1] + '/' + to[2];
            });

            const dataEvent = (e) => {
                // console.log('dataEvent => ', e,currentPage.title)
                isAction.value = e[currentPage.title]['action'];
                isSearch.value = e[currentPage.title]['search'];
            };

            const closeSuccessModalHandler = async () => {
                await store.dispatch('setSuccessModal', false);
            };

            const closeErrorModalHandler = async () => {
                await store.dispatch('setErrorModal', false);
            };
            const btnActionsHandler = (btnTyp, pageName) => {
                currentPage.btnShow = false;
                currentPage.btnHeaderShow = true;
                store.dispatch('setBtnHeader', true)

                currentPage.btnBackShow = false;
                currentPage.title = btnTyp === 'teams' ? 'team' : btnTyp;
                currentPage.name = btnTyp === 'teams' ? 'entity' : btnTyp;
                currentPage.to = '/settings/' + pageName + '/create';
                currentPage.access = permissions.value.includes('create ' + `${currentPage.name}`);
                currentPage.backRoute = '/settings/' + pageName;
                setTimeout(() => {
                    currentPage.btnShow = true;
                }, 200)
            };

            const btnCreateActionsHandler = (btnTyp, pageName) => {
                currentPage.btnShow = false;
                currentPage.btnHeaderShow = false;
                store.dispatch('setBtnHeader', false)

                currentPage.btnBackShow = true;
                let to = currentPage.to.split('/');
                currentPage.backRoute = '/' + to[1] + '/' + to[2];
            };
            const subIsActive = (input) => {
                const paths = Array.isArray(input) ? input : [input];
                return paths.some(path => {
                    return route.path.indexOf(path) === 0 // current path starts with this path string
                })
            };

            return {
                permissions,
                currentPage,
                isAction,
                isSearch,
                editFlag: computed(() => store.state.settings.editFlag),
                successModal: computed(() => store.state.settings.successModal),
                errorModal: computed(() => store.state.settings.errorModal),
                successMessage: computed(() => store.state.settings.successMessage),
                errorMessage: computed(() => store.state.settings.errorMessage),
                setDataFlag: computed(() => store.state.settings.setDataFlag),

                dataEvent,
                closeErrorModalHandler,
                closeSuccessModalHandler,
                subIsActive,
                btnCreateActionsHandler,
                btnActionsHandler
            }
        },
    }
</script>

<style>
    .page-container{
        padding: 22.5px;
    }

    .header-text{
        font-family: Poppins,sans-serif;
        font-size: 25px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
    }
    /*.tab {*/
    /*    overflow: hidden;*/
    /*    display: flex;*/
    /*    gap: 10px;*/
    /*}*/

    /*.tab .tablinks {*/
    /*    width: 107px;*/
    /*    height: 41px;*/
    /*    background-color: #10293352;*/
    /*    color: #fff;*/
    /*    float: left;*/
    /*    border: none;*/
    /*    outline: none;*/
    /*    cursor: pointer;*/
    /*    padding: 8px 16px;*/
    /*    transition: 0.3s;*/
    /*    font-size: 16px;*/
    /*    font-family: Poppins,sans-serif;*/
    /*    font-weight: normal;*/
    /*    font-stretch: normal;*/
    /*    font-style: normal;*/
    /*    line-height: normal;*/
    /*    letter-spacing: normal;*/
    /*    text-align: center;*/
    /*    border-radius: 10px 10px 0 0;*/
    /*}*/

    /*.tab .tablinks:hover,*/
    /*.tab .tablinks.active {*/

    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*    color: #e37450;*/
    /*}*/



    .setting-action {
        text-decoration: none;
        cursor: pointer;
        background-color: #E95626;
        border-radius: 10px;
        color: #FFF;
        font-weight: 700;
        padding: 10px 38px;
        font-size: 16px;
        height: fit-content;
    }


    .setting-action:hover {
        color: #FFF;
    }

    /* we will explain what these classes do next! */
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    .back-route {
        text-decoration: none;
        cursor: pointer;
        color: #FFF;
        font-size: 22px;
    }

    .back-route:hover {
        color: #FFF;
    }
</style>